import { userConstants } from '../constants';
import { AuthActions } from './';
import { UserApi } from '../services';

export class UserActions {
    static getAllUsers () {
        return (dispatch) => {
            dispatch({type: userConstants.GET_ALL_USERS_REQEUST});

            UserApi.getAllUsers()
                .then(AuthActions.ok(dispatch))
                .then((res) => {
                    // success
                    if(res.meta.success === true && res.data) {
                        dispatch({type: userConstants.GET_ALL_USERS_SUCCESS, payload: [...res.data]});
                        return;
                    }

                    return dispatch({type: userConstants.GET_ALL_USERS_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: userConstants.GET_ALL_USERS_FAILURE});
                });
        }
    }

    static getAccountAccess (data) {
        return (dispatch) => {
            dispatch({type: userConstants.GET_USER_ACCOUNT_ACCESS_REQEUST});

            UserApi.getAccountAccess(data)
                .then(AuthActions.ok(dispatch))
                .then((res) => {
                    // success
                    if(res.meta.success === true) {
                        dispatch({type: userConstants.GET_USER_ACCOUNT_ACCESS_SUCCESS});
                        
                        const link = document.createElement('a');
                        link.href = process.env.REACT_APP_USER_APP_URL
                        link.target = '_blank';
                        link.click();

                        return;
                    }

                    return dispatch({type: userConstants.GET_USER_ACCOUNT_ACCESS_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: userConstants.GET_USER_ACCOUNT_ACCESS_FAILURE});
                });
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/user.js